//compass todo
import {
  AfterViewInit, Component, OnInit, OnDestroy, ViewChild,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Viewer, ScreenSpaceEventHandler, ScreenSpaceEventType, Ellipsoid, Math as CesiumMath, sampleTerrain } from 'cesium';
import * as Cesium from 'cesium';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogoutComponent } from '../logout/logout.component';
import { SettingsDialogComponent } from '../setting/settings-dialog/settings-dialog.component';
import { GlobeService } from '../../../core/services/globe.service';
import { CoresService } from '../../../core/services/cores.service';
import { OverlappingEntitiesService } from '../../../core/services/overlapping-entities.service';
import { CameraService } from '../../../core/services/camera.service';
import { CoreService } from '../../../core/services/core.service';
import { catchError, distinctUntilChanged, expand, Observable, of, Subject, Subscription, switchMap, take, takeUntil, timer } from 'rxjs';
//compass todo
import CesiumNavigation from "cesium-navigation-es6"; // or the correct path if local
import { AlertService } from '../../../core/services/alert.service';
import { RealtimeService, Incident } from '../../../core/services/realtime.service';
import { NotificationService } from '../../../core/services/notification.service';
import { NotificationComponent } from '../notification/notification.component';
import { SavedView } from '../../../core/interfaces/view.model';
import { ConfigurationManagerService } from '../../../core/services/configuration-manager.service';
import { OrganizationUtilService } from '../../../core/services/organization-util.service';
import { VehicleMonitorService, VehicleMonitorSnapshot } from '../../../core/services/vehicle-monitor.service';
import { GeofenceService } from '../../../core/services/geofence.service';
import { CdrGlobeService, REGION_COLORS, HoverTooltipInfo } from '../../../core/services/cdr-globe.service';
import { CdrLegendComponent } from './cdr-legend/cdr-legend.component';
import { CdrTowerDetailsModalComponent } from './cdr-tower-details/cdr-tower-details-modal.component';
import { GtdGlobeService, GtdHoverTooltipInfo } from '../../../core/services/gtd-globe.service';
import { GtdControlPanelComponent } from './gtd-control-panel/gtd-control-panel.component';
import { GtdIncidentModalComponent } from './gtd-incident-modal/gtd-incident-modal.component';
import { FlightRadarGlobeService } from '../../../core/services/flight-radar-globe.service';
import { CommonModule } from '@angular/common';
import { VehicleCampusLegendComponent } from './vehicle-campus-legend/vehicle-campus-legend.component';
import { VehicleMonitorMarkerService, VehicleHoverTooltipInfo } from '../../../core/services/vehicle-monitor-markers.service';

@Component({
  selector: 'app-globe',
  standalone: true,
  imports: [
    CommonModule,
    NotificationComponent,
    CdrLegendComponent,
    CdrTowerDetailsModalComponent,
    GtdControlPanelComponent,
    GtdIncidentModalComponent,
    VehicleCampusLegendComponent
  ],
  templateUrl: './globe.component.html',
  styleUrl: './globe.component.css',
})
export class GlobeComponent implements OnInit, AfterViewInit, OnDestroy {
  drawerOpen: boolean = false;
  isMonitorMode: boolean = false;
  showCustomButton: boolean = false;
  viewer!: Viewer;
  isToolActive: boolean = false;
  private toolActiveSub?: Subscription;
  buildingRows: any[] = [];
  // Add these properties
  private realtimeSubscriptions: Subscription[] = [];
  currentIncidents: Incident[] = [];
  showNotifications = true; // Open notifications by default on every refresh
  savedViews: SavedView[] = [];
  hoverTooltip$: Observable<HoverTooltipInfo | null>;
  gtdHoverTooltip$: Observable<GtdHoverTooltipInfo | null>;
  vehicleHoverTooltip$: Observable<VehicleHoverTooltipInfo | null>;
  private globeClickHandler?: ScreenSpaceEventHandler;
  private readonly vehiclePollStop$ = new Subject<void>();
  private vehicleViewCameraSaved?: {
    enableTilt: boolean;
    enableLook: boolean;
    enableZoom: boolean;
    enableTranslate: boolean;
  };
  private vehicleViewFramed = false;
  private vehicleLayerOn = false;

  //compass todo
  @ViewChild('compass', { static: true }) compass!: ElementRef;
  @ViewChild('controls', { static: true }) controls!: ElementRef;

  constructor(
    private modalService: NgbModal,
    private globeService: GlobeService,
    private coreService: CoresService,
    private overlappingEntitiesService: OverlappingEntitiesService,
    private cameraService: CameraService,
    private corService: CoreService,
    private alertService: AlertService,
    private renderer: Renderer2,
    private realtimeService: RealtimeService,
    private notificationService: NotificationService,
    private orgUtilService: OrganizationUtilService,
    public cdrGlobeService: CdrGlobeService,
    public gtdGlobeService: GtdGlobeService,
    public flightRadarGlobeService: FlightRadarGlobeService,
    public vehicleMonitor: VehicleMonitorService,
    private vehicleMarkers: VehicleMonitorMarkerService,
    private geofenceService: GeofenceService,
  ) {
    this.hoverTooltip$ = this.cdrGlobeService.hoverTooltip$;
    this.gtdHoverTooltip$ = this.gtdGlobeService.hoverTooltip$;
    this.vehicleHoverTooltip$ = this.vehicleMarkers.hoverTooltip$;
  }

  ngOnInit(): void {
    this.toolActiveSub = this.corService.toolActive$.subscribe(isActive => {
      this.isToolActive = isActive;
    });

    // Listen for custom refresh event
    window.addEventListener('refreshNotifications', () => {
      this.refreshNotificationsFromAPI();
    });

    window.addEventListener('orgUpdated', () => {
      this.ensureIntelButtons();
    });

    this.realtimeSubscriptions.push(
      this.vehicleMonitor.selectedCampusId$.subscribe(() => {
        const snapshot = this.vehicleMonitor.latestSnapshot();
        if (!snapshot || !this.vehicleMonitor.isVehicleViewOn()) {
          return;
        }
        this.vehicleMarkers.apply(this.campusFilteredSnapshot(snapshot), true);
      }),
      this.vehicleMonitor.vehicleViewOn$.pipe(distinctUntilChanged()).subscribe((on) => {
        this.syncVehicleViewLayer(on);
      })
    );

    const intelCheckTimer = setInterval(() => {
      this.ensureIntelButtons();
    }, 400);
    setTimeout(() => clearInterval(intelCheckTimer), 10000);
  }
  ngAfterViewInit(): void {
    this.initCesiumViewer();
    this.moveNavigation(true); // Make sure compass/controls are present in DOM
    this.globeService.setViewer(this.viewer);
    this.globeService.setMapboxImageryProviders();
    this.coreService.setViewer(this.viewer);
    this.corService.setViewer(this.viewer);
    this.alertService.processPendingAlerts();
    this.setupGlobeClickHandler();
    this.initializeRealTimeNotifications();
    this.cdrGlobeService.init(this.viewer);
    this.gtdGlobeService.init(this.viewer);
    this.flightRadarGlobeService.init(this.viewer);
    setTimeout(() => this.addCustomButton(), 0); // Defer to ensure DOM readiness
    // Add Cesium navigation controls
    new CesiumNavigation(this.viewer, {
      defaultResetView: Cesium.Rectangle.fromDegrees(2.6, 4.0, 14.8, 14.0),
      enableCompass: true,
      enableZoomControls: true,
      enableDistanceLegend: true,
      enableCompassOuterRing: true,
      zoomInTooltip: 'Zoom In',
      zoomOutTooltip: 'Zoom Out',
      resetTooltip: 'Reset View',
    });

    this.viewer.clock.shouldAnimate = true;
    this.viewer.clock.onTick.addEventListener((clock) => {
      this.corService.fireOnTickEventHandlers(clock, clock.currentTime);
    });
    if (this.viewer && this.viewer.scene && this.viewer.scene.globe) {
      this.viewer.scene.globe.maximumScreenSpaceError = 8; // Less detail, fewer tiles
    }
    this.savedDefaultView()
    this.cameraService.start();
    this.addCompassTitle();
  }

  addCompassTitle() {
    setTimeout(() => {
      // Map each class/selector to its tooltip text
      const tooltipMap: Record<string, string> = {
        '.compass-outer-ring': 'Click and drag to rotate the camera',
        '.compass': 'Drag outer ring: rotate view. Drag inner gyroscope: free orbit.Double-click: reset view.TIP: You can also free orbit by holding the CTRL key and dragging the map.',
      };

      Object.entries(tooltipMap).forEach(([selector, tooltipText]) => {
        const elements = document.querySelectorAll<HTMLElement>(`#navigationDiv ${selector}`);

        elements.forEach((el: HTMLElement) => {
          if (!el) return;

          // Native browser tooltip
          el.setAttribute('title', tooltipText);
        });
      });
    }, 500);
  }

  savedDefaultView() {
    // Override Cesium Home button
    if (this.viewer && this.viewer.homeButton) {
      this.viewer.homeButton.viewModel.command.beforeExecute.addEventListener((e) => {

        this.goHome();
      });
    }
  }

  goHome() {
    const userOrgId = (localStorage.getItem('PAA_org') ?? '').trim();
    if (userOrgId === '2025') {
      this.cdrGlobeService.closeBuildingCamera();
      if (this.viewer?.camera) {
        this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
      }
      this.cdrGlobeService.flyToNigeria();
      return;
    }

    this.loadSavedViews();
    const defaultView = this.savedViews.find(v => v.isDefault);
    this.buildingRows = this.orgUtilService.buildingRows;
    const campusRows = this.orgUtilService.data?.myCampus?.campuses || [];
    const campusId = campusRows[0]?.campusId;
    if (campusRows.length >= 1) {
      const coords = campusRows[0]?.campusPosition?.coordinates;
      if (coords?.length === 2) {
        const destination = Cesium.Cartesian3.fromDegrees(
          coords[0],
          coords[1],
          5000
        );

        this.cameraService.flyTo({
          destination,
          complete: () => {
            const building = this.orgUtilService.data?.myBuildings?.find(
              (b: any) => Number(b.perimeterId) === Number(campusId)
            );
            const entity = building?.pin;
            entity?.viewDetailsWindow?.(entity);
          },
        });
      }
    } else if (this.buildingRows.length === 1) {
      const coords = this.buildingRows[0].position.coordinates;
      const latitude = coords[1];
      const longitude = coords[0];
      const altitude = 1000;
      const destination = Cesium.Cartesian3.fromDegrees(longitude, latitude, altitude);
      setTimeout(() => {
        this.cameraService.flyTo({
          destination,
          complete: () => {
            const entity = this.orgUtilService.data.myBuildings[0]?.pin;
            entity?.viewDetailsWindow?.(entity);
          },
        });
      }, 0);
    } else if (defaultView && this.viewer) {
      this.cameraService.flyHome(1);
    } else if (this.viewer) {
      this.initializeCesiumNavigation();
    } else {
      this.cdrGlobeService.flyToNigeria();
    }
  }

  private initializeCesiumNavigation(): void {
    // Delay initialization slightly to ensure viewer is ready
    setTimeout(() => {
      if (!this.viewer) return;

      // Initialize navigation controls
      new CesiumNavigation(this.viewer, {
        defaultResetView: Cesium.Rectangle.fromDegrees(2.2, 3.5, 15.2, 14.5),
        enableCompass: true,
        enableZoomControls: true,
        enableDistanceLegend: true,
        enableCompassOuterRing: true,
        zoomInTooltip: 'Zoom In',
        zoomOutTooltip: 'Zoom Out',
        resetTooltip: 'Reset View',
      });

      // Fly camera to default position (Nigeria)
      this.flyToDefaultView();
    }, 100);
  }

  private flyToDefaultView(): void {
    //  this.cdrGlobeService.flyToNigeria();
    this.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(-98.0, 40.0, 25000000),
      orientation: {
        heading: Cesium.Math.toRadians(0.0),
        pitch: Cesium.Math.toRadians(-90.0),
        roll: 0.0,
      },
    });
  }

  loadSavedViews() {
    const savedViewsJson = localStorage.getItem('savedViews');
    if (savedViewsJson) {
      try {
        this.savedViews = JSON.parse(savedViewsJson) as SavedView[];
      } catch (e) {
        this.savedViews = [];
      }
    } else {
      this.savedViews = [];
    }
  }

  ngOnDestroy(): void {
    this.toolActiveSub?.unsubscribe();

    this.vehiclePollStop$.next();
    this.vehiclePollStop$.complete();
    this.restoreVehicleViewCameraControls();

    // Cleanup real-time subscriptions
    this.realtimeSubscriptions.forEach(sub => sub.unsubscribe());
    this.realtimeSubscriptions = [];

    // Disconnect real-time service
    this.realtimeService.disconnect();

    if (this.globeClickHandler && !this.globeClickHandler.isDestroyed()) {
      try { this.globeClickHandler.destroy(); } catch (e) { }
      this.globeClickHandler = undefined;
    }

    // Cleanup CDR service
    this.cdrGlobeService.destroy();

    // Cleanup GTD service
    this.gtdGlobeService.destroy();

    if (this.viewer && !this.viewer.isDestroyed()) {
      try { this.viewer.destroy(); } catch (e) { }
    }
  }
  private initCesiumViewer(): void {
    // Cesium.Camera.DEFAULT_VIEW_RECTANGLE = Cesium.Rectangle.fromDegrees(2.2, 3.5, 15.2, 14.5);
    // Cesium.Camera.DEFAULT_VIEW_FACTOR = 0.0;

    Cesium.Ion.defaultAccessToken = ConfigurationManagerService.settings.CesiumToken;

    this.viewer = new Viewer('cesiumContainer', {
      animation: true,
      timeline: false,
      baseLayerPicker: true,
      fullscreenButton: false,
      geocoder: true,
      homeButton: true,
      infoBox: true,
      sceneModePicker: true,
      selectionIndicator: false,
      navigationHelpButton: true,
      navigationInstructionsInitiallyVisible: false,
      shouldAnimate: true,
      terrainProviderViewModels: [],
      contextOptions: {
        webgl: {
          failIfMajorPerformanceCaveat: false,
        },
      },
      requestRenderMode: true,
    });
    new CesiumNavigation(this.viewer, {
      defaultResetView: Cesium.Rectangle.fromDegrees(-180, -90, 180, 90),
      enableCompass: true,
      enableZoomControls: true,
      enableDistanceLegend: true,
      enableCompassOuterRing: true,
      zoomInTooltip: 'Zoom In',
      zoomOutTooltip: 'Zoom Out',
      resetTooltip: 'Reset View',
    });
  }

  moveNavigation(left: boolean): void {
    const shiftAmount = 410 * (left ? -1 : 1);

    [this.compass, this.controls].forEach((elementRef, index) => {
      if (!elementRef?.nativeElement) {
        return;
      }

      const el = elementRef.nativeElement as HTMLElement;
      const computedLeft = getComputedStyle(el).left;
      const currentLeft = (computedLeft && computedLeft !== 'auto')
        ? parseInt(computedLeft, 10)
        : 0;

      const newLeft = currentLeft + shiftAmount;
      this.renderer.setStyle(el, 'left', `${newLeft}px`);
    });
  }

  setupGlobeClickHandler() {
    if (this.globeClickHandler && !this.globeClickHandler.isDestroyed()) {
      try { this.globeClickHandler.destroy(); } catch (e) { }
    }
    this.globeClickHandler = new ScreenSpaceEventHandler(this.viewer.scene.canvas);
    this.globeClickHandler.setInputAction((event: any) => this.onGlobeClick(event), ScreenSpaceEventType.LEFT_CLICK);
  }

  onGlobeClick(event: any): void {
    const scene = this.viewer.scene;
    const pickedObjects = scene.drillPick(event.position, 200);

    if (this.isVehicleMonitorPick(pickedObjects) && !this.hasAlertPick(pickedObjects)) {
      return;
    }

    if (typeof this.overlappingEntitiesService.hideOverlappingEntities === 'function') {
      this.overlappingEntitiesService.hideOverlappingEntities();
    }

    const showVisualization = true;

    if (pickedObjects && pickedObjects.length > 0 && showVisualization) {
      const modifiedObjects = this.modifyObjects(pickedObjects);

      if (modifiedObjects.length === 1) {
        const pickedObject = modifiedObjects[0];
        if (pickedObject.type === 'ALERT') {
          this.cameraService.runAlert(new MouseEvent('click'), pickedObject?.entity?.object);
        } else {
          this.openMapEntityDetailsWindow(pickedObject);
        }
      } else if (modifiedObjects.length > 1) {
        if (typeof this.overlappingEntitiesService.showOverlappingEntities === 'function') {
          this.overlappingEntitiesService.showOverlappingEntities(modifiedObjects, event.position);
        }
      }
    } else {
      const position = this.viewer.camera.pickEllipsoid(event.position);
      if (Cesium.defined(position) && position) {
        const cartographicPosition = Ellipsoid.WGS84.cartesianToCartographic(position);
        const lon = CesiumMath.toDegrees(cartographicPosition.longitude);
        const lat = CesiumMath.toDegrees(cartographicPosition.latitude);
        sampleTerrain(this.viewer.terrainProvider, 9, [cartographicPosition]).then(() => {
          const height = cartographicPosition.height;
          if (typeof this.corService.fireGlobeClickEventHandlers === 'function') {
            this.corService.fireGlobeClickEventHandlers(lat, lon, height);
          }
        });
      }
    }
  }

  modifyObjects(objects: any[]): any[] {
    const newList: any[] = [];
    for (const obj of objects) {
      const arcLiveMapEntity = this.getArcLiveMapEntity(obj);
      if (arcLiveMapEntity && arcLiveMapEntity.showInOverlappingEntitiesUI()) {
        newList.push(arcLiveMapEntity);
      }
      if (obj.id && obj.id.type === 'alertCluster' && Array.isArray(obj.id.members)) {
        for (const m of obj.id.members) {
          if (m.alertEntity) {
            newList.push(m.alertEntity);
          }
        }
      }
    }
    return newList;
  }

  getArcLiveMapEntity(object: any): any {
    if (object?.id?.arcLiveMapEntity !== undefined) {
      return object.id.arcLiveMapEntity;
    } else if (object?.primitive?.arcLiveMapEntity !== undefined) {
      return object.primitive.arcLiveMapEntity;
    }
    return undefined;
  }

  private hasAlertPick(pickedObjects: any[]): boolean {
    if (!pickedObjects?.length) {
      return false;
    }
    return pickedObjects.some((obj) => {
      const id = obj?.id;
      if (id?.type === 'alertCluster') {
        return true;
      }
      if (id?.alertEntity || id?.type === 'Alert Marker') {
        return true;
      }
      const entity = this.getArcLiveMapEntity(obj);
      return entity?.type === 'ALERT';
    });
  }

  private isVehicleMonitorPick(pickedObjects: any[]): boolean {
    if (!pickedObjects?.length) {
      return false;
    }
    return pickedObjects.some((obj) => {
      const id = obj?.id;
      if (typeof id === 'string' && id.startsWith('vehicle-monitor:')) {
        return true;
      }
      if (typeof id?.id === 'string' && id.id.startsWith('vehicle-monitor:')) {
        return true;
      }
      return false;
    });
  }

  openMapEntityDetailsWindow(mapEntity: any): void {
    this.globeService.handleClick(this, mapEntity);
  }

  // Add this method
  private initializeRealTimeNotifications(): void {

    // Start the real-time service
    this.realtimeService.connect();

    // Subscribe to all incidents updates
    const allIncidentsSub = this.realtimeService.allIncidents.subscribe(
      incidents => {
        this.currentIncidents = incidents;
      }
    );
    this.realtimeSubscriptions.push(allIncidentsSub);

    // Subscribe to new incidents
    const newIncidentsSub = this.realtimeService.incidents.subscribe(
      incident => {
        // Additional handling for new incidents if needed
        // You could add custom logic here like updating the map, etc.
      }
    );
    this.realtimeSubscriptions.push(newIncidentsSub);

    // Subscribe to connection status
    const connectionSub = this.realtimeService.connectionStatus.subscribe(
      status => {
        if (status === 'connected') {
        } else if (status === 'disconnected') {
          // You could show a notification about disconnection here
        }
      }
    );
    this.realtimeSubscriptions.push(connectionSub);
  }

  showHideDrawer() {
    this.drawerOpen = !this.drawerOpen;
    this.isMonitorMode = !this.isMonitorMode;

    // Toggle button visibility based on drawer state
    this.showCustomButton = this.drawerOpen;

    const btn = document.getElementById('customToolbarBtn');
    if (btn) {
      btn.style.display = this.showCustomButton ? 'inline-block' : 'none';
    }
  }

  addCustomButton() {
    const toolbar = document.querySelector('.cesium-viewer-toolbar');
    if (!toolbar) return;

    // Ensure CDR, TD, and Vehicle View buttons are added if org is 2025
    this.ensureIntelButtons();

    if (
      (toolbar as HTMLElement).querySelector('.sign-out-btn') ||
      (toolbar as HTMLElement).querySelector('.settings-btn') ||
      (toolbar as HTMLElement).querySelector('.notification-btn')
    )
      return;

    const spacer = document.createElement('div');
    spacer.style.flex = '1';
    toolbar.appendChild(spacer);

    // Create the Notification button with proper Font Awesome bell icon
    const notificationButton = document.createElement('button');
    notificationButton.className = 'cesium-button notification-btn';
    notificationButton.style.marginLeft = '5px';
    notificationButton.style.position = 'relative';

    // Use the Font Awesome bell icon (regular style)
    notificationButton.innerHTML = '<i class="fa-regular fa-bell"></i>';
    notificationButton.title = 'Notifications';

    // Add notification badge if there are active notifications
    this.addNotificationBadge(notificationButton);

    notificationButton.addEventListener('click', () => {
      this.handleNotifications();
    });

    // Create the Settings button
    const settingsButton = document.createElement('button');
    settingsButton.className = 'cesium-button settings-btn';
    settingsButton.style.marginLeft = '5px';
    settingsButton.innerHTML = '<i class="fa fa-cog"></i>';
    settingsButton.title = 'Settings';
    settingsButton.addEventListener('click', () => {
      this.handleSettings();
    });

    // Create the Sign Out button
    const signOutButton = document.createElement('button');
    signOutButton.className = 'cesium-button sign-out-btn';
    signOutButton.style.marginLeft = '5px';
    signOutButton.innerHTML = '<i class="fa fa-sign-out-alt"></i>';
    signOutButton.title = 'Sign Out';
    signOutButton.addEventListener('click', () => {
      this.handleSignOut();
    });

    // Ensure toolbar uses flex layout
    (toolbar as HTMLElement).style.display = 'flex';
    (toolbar as HTMLElement).style.alignItems = 'center';

    toolbar.appendChild(notificationButton);
    toolbar.appendChild(settingsButton);
    toolbar.appendChild(signOutButton);
  }

  private removeVehicleViewButton(toolbar: HTMLElement): void {
    toolbar.querySelector('.vehicle-view-btn')?.remove();
    if (this.vehicleMonitor.isVehicleViewOn()) {
      this.vehicleMonitor.setVehicleViewOn(false);
    }
  }

  private ensureVehicleViewButton(toolbar: HTMLElement): void {
    let vehicleViewButton = toolbar.querySelector('.vehicle-view-btn') as HTMLButtonElement | null;
    if (!vehicleViewButton) {
      vehicleViewButton = document.createElement('button');
      vehicleViewButton.type = 'button';
      vehicleViewButton.className = 'cesium-button vehicle-view-btn';
      vehicleViewButton.style.margin = '0 3px';
      vehicleViewButton.innerHTML = '<i class="fa-solid fa-car"></i>';
      vehicleViewButton.title = 'Vehicle View';
      vehicleViewButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleVehicleViewFromToolbar();
      });
      this.realtimeSubscriptions.push(
        this.vehicleMonitor.vehicleViewOn$.subscribe((on) => {
          vehicleViewButton!.classList.toggle('active', on);
        })
      );
    }

    const intelGroup = toolbar.querySelector('.cesium-toolbar-intel-group');
    if (intelGroup) {
      const flightBtn = intelGroup.querySelector('.flight-toolbar-btn');
      if (flightBtn) {
        if (flightBtn.nextSibling !== vehicleViewButton) {
          intelGroup.insertBefore(vehicleViewButton, flightBtn.nextSibling);
        }
      } else if (intelGroup.firstChild !== vehicleViewButton) {
        intelGroup.insertBefore(vehicleViewButton, intelGroup.firstChild);
      }
    } else if (toolbar.firstChild !== vehicleViewButton) {
      toolbar.insertBefore(vehicleViewButton, toolbar.firstChild);
    }
  }

  private toggleVehicleViewFromToolbar(): void {
    const userOrgId = (localStorage.getItem('PAA_org') ?? '').replace(/["']/g, '').trim();
    if (userOrgId !== '2025') {
      return;
    }
    this.vehicleMonitor.setVehicleViewOn(!this.vehicleMonitor.isVehicleViewOn());
  }

  private syncVehicleViewLayer(on: boolean): void {
    if (on) {
      if (this.vehicleLayerOn) {
        return;
      }
      this.vehicleLayerOn = true;
      this.vehicleViewFramed = false;
      this.lockVehicleViewTopDownZoom();
      this.pushIllumGeofences();
      return;
    }
    if (!this.vehicleLayerOn) {
      return;
    }
    this.vehicleLayerOn = false;
    this.stopVehicleMonitorLayer();
  }

  private pushIllumGeofences(): void {
    this.geofenceService.getCampuses().pipe(
      catchError(() => of([])),
      take(1)
    ).subscribe((rows) => {
      const geofences = (rows || [])
        .filter((row) => row?.id && row?.geometry && Array.isArray(row.geometry.coordinates))
        .map((row) => ({
          id: row.id,
          label: row.label,
          perimeterType: row.type,
          type: row.geometry?.type,
          coordinates: row.geometry?.coordinates,
          geometry: row.geometry
        }));
      this.vehicleMonitor.setIllumGeofences(geofences).pipe(catchError(() => of(null))).subscribe(() => {
        this.autoStartVehiclePlayback();
      });
    });
  }

  private flyToVehicleViewOverview(): void {
    return;
  }

  private frameVehicleFleet(_vehicles?: { latitude?: number; longitude?: number }[]): boolean {
    return false;
  }

  private lockVehicleViewTopDownZoom(): void {
    const controller = this.viewer?.scene?.screenSpaceCameraController;
    if (!controller) {
      return;
    }
    if (!this.vehicleViewCameraSaved) {
      this.vehicleViewCameraSaved = {
        enableTilt: controller.enableTilt,
        enableLook: controller.enableLook,
        enableZoom: controller.enableZoom,
        enableTranslate: controller.enableTranslate
      };
    }
    controller.enableZoom = true;
    controller.enableTranslate = true;
    controller.enableRotate = true;
    controller.enableTilt = false;
    controller.enableLook = false;
  }

  private restoreVehicleViewCameraControls(): void {
    const controller = this.viewer?.scene?.screenSpaceCameraController;
    const saved = this.vehicleViewCameraSaved;
    if (!controller || !saved) {
      return;
    }
    controller.enableTilt = saved.enableTilt;
    controller.enableLook = saved.enableLook;
    controller.enableZoom = saved.enableZoom;
    controller.enableTranslate = saved.enableTranslate;
    this.vehicleViewCameraSaved = undefined;
  }

  private autoStartVehiclePlayback(): void {
    this.vehicleMonitor.command('reset').pipe(
      catchError(() => of(null)),
      switchMap(() => this.vehicleMonitor.command('speed', 1)),
      catchError(() => of(null)),
      switchMap(() => this.vehicleMonitor.command('start')),
      catchError(() => of(null)),
      takeUntil(this.vehiclePollStop$)
    ).subscribe({
      next: () => this.startVehiclePoll(),
      error: () => this.startVehiclePoll()
    });
  }

  private startVehiclePoll(): void {
    this.vehiclePollStop$.next();
    this.vehicleMonitor.snapshot().pipe(
      catchError((error) => of({
        success: false,
        message: error?.error?.message || error?.message || 'Vehicle monitor unavailable',
        data: null
      })),
      expand((response) => {
        const state = response?.data?.simulation?.state;
        const tickMs = this.vehicleMonitor.playbackTickMs(response?.data?.simulation);
        const waitMs = state === 'RUNNING' ? Math.max(100, Math.min(250, tickMs)) : 1000;
        return timer(waitMs).pipe(
          switchMap(() => this.vehicleMonitor.snapshot().pipe(
            catchError((error) => of({
              success: false,
              message: error?.error?.message || error?.message || 'Vehicle monitor unavailable',
              data: null
            }))
          ))
        );
      }),
      takeUntil(this.vehiclePollStop$)
    ).subscribe((response) => {
      if (!this.vehicleMonitor.isVehicleViewOn()) {
        return;
      }
      if (!response?.success || !response.data) {
        return;
      }
      this.vehicleMonitor.setLatestSnapshot(response.data);
      this.vehicleMonitor.publishUnauthorizedEntryAlerts(response.data);
      this.vehicleMarkers.apply(this.campusFilteredSnapshot(response.data), true);
    });
  }

  private campusFilteredSnapshot(snapshot: VehicleMonitorSnapshot): VehicleMonitorSnapshot {
    const campusId = this.vehicleMonitor.selectedCampusId();
    if (!campusId) {
      return snapshot;
    }
    const campus = (snapshot.campuses || []).find((row) => row.id === campusId)
      || (snapshot.counts?.byCampus || []).find((row) => row.id === campusId);
    const labelKey = String(campus?.label || '').trim().toLowerCase();
    return {
      ...snapshot,
      vehicles: snapshot.vehicles.filter((vehicle) =>
        vehicle.campusId === campusId ||
        (!!labelKey && String(vehicle.homeCampusKey || '').toLowerCase() === labelKey)
      )
    };
  }

  private stopVehicleMonitorLayer(): void {
    this.vehiclePollStop$.next();
    this.vehicleMonitor.command('reset').pipe(catchError(() => of(null)), take(1)).subscribe();
    this.vehicleMarkers.clear();
    this.vehicleMonitor.setLatestSnapshot(null);
    this.vehicleMonitor.clearPostedGeofenceAlerts();
    this.restoreVehicleViewCameraControls();
    this.vehicleViewFramed = false;
  }

  ensureIntelButtons(): void {
    const toolbar = document.querySelector('.cesium-viewer-toolbar');
    if (!toolbar) return;

    const existingIntelGroup = toolbar.querySelector('.cesium-toolbar-intel-group');
    const rawOrg = localStorage.getItem('PAA_org') ?? '';
    const userOrgId = rawOrg.replace(/["']/g, '').trim();

    if (userOrgId === '2025') {
      if (existingIntelGroup) {
        this.ensureVehicleViewButton(toolbar as HTMLElement);
        return;
      }

      // Create the CDR Telecom Towers button with cyan border outline
      const cdrButton = document.createElement('button');
      cdrButton.className = 'cesium-button cdr-toolbar-btn';
      cdrButton.style.display = 'inline-flex';
      cdrButton.style.alignItems = 'center';
      cdrButton.style.justifyContent = 'center';
      cdrButton.style.width = '36px';
      cdrButton.style.height = '36px';
      cdrButton.style.padding = '0';
      cdrButton.style.margin = '0 3px';
      cdrButton.style.boxSizing = 'border-box';
      cdrButton.style.borderRadius = '4px';
      cdrButton.style.border = '1.5px solid #00F0FF';
      cdrButton.style.background = 'rgba(0, 240, 255, 0.15)';
      cdrButton.style.color = '#00F0FF';
      cdrButton.style.cursor = 'pointer';
      cdrButton.style.verticalAlign = 'middle';
      cdrButton.innerHTML = '<i class="fa-solid fa-satellite-dish" style="font-size: 24px; line-height: 1; pointer-events: none;"></i>';
      cdrButton.title = 'Nigeria CDR Telecom Towers Overview';

      const cdrSub = this.cdrGlobeService.isLayerVisible$.subscribe(visible => {
        cdrButton.classList.toggle('active', visible);
        if (visible) {
          cdrButton.style.background = 'rgba(0, 240, 255, 0.45)';
          cdrButton.style.color = '#FFFFFF';
          cdrButton.style.boxShadow = '0 0 10px rgba(0, 240, 255, 0.7)';
        } else {
          cdrButton.style.background = 'rgba(0, 240, 255, 0.15)';
          cdrButton.style.color = '#00F0FF';
          cdrButton.style.boxShadow = 'none';
        }
      });
      this.realtimeSubscriptions.push(cdrSub);

      cdrButton.addEventListener('click', () => {
        this.showCesiumToolbarButtons();
        this.cdrGlobeService.closeBuildingCamera();
        const isVisible = this.cdrGlobeService.isLayerVisible();
        if (!isVisible) {
          this.cdrGlobeService.toggleLayer(true);
          this.cdrGlobeService.flyToNigeria();
        } else {
          this.cdrGlobeService.toggleLayer(false);
        }
      });

      // Create the GTD Global Terrorism Intelligence button with red border outline
      const gtdButton = document.createElement('button');
      gtdButton.className = 'cesium-button gtd-toolbar-btn';
      gtdButton.style.display = 'inline-flex';
      gtdButton.style.alignItems = 'center';
      gtdButton.style.justifyContent = 'center';
      gtdButton.style.width = '36px';
      gtdButton.style.height = '36px';
      gtdButton.style.padding = '0';
      gtdButton.style.margin = '0 6px 0 3px';
      gtdButton.style.boxSizing = 'border-box';
      gtdButton.style.borderRadius = '4px';
      gtdButton.style.border = '1.5px solid #EF4444';
      gtdButton.style.background = 'rgba(239, 68, 68, 0.18)';
      gtdButton.style.color = '#EF4444';
      gtdButton.style.cursor = 'pointer';
      gtdButton.style.verticalAlign = 'middle';
      gtdButton.innerHTML = '<i class="fa-solid fa-burst" style="font-size: 24px; line-height: 1; pointer-events: none;"></i>';
      gtdButton.title = 'Terrorism Database (TD) Intelligence';

      const gtdSub = this.gtdGlobeService.isLayerVisible$.subscribe(visible => {
        gtdButton.classList.toggle('active', visible);
        if (visible) {
          gtdButton.style.background = 'rgba(239, 68, 68, 0.55)';
          gtdButton.style.color = '#FFFFFF';
          gtdButton.style.boxShadow = '0 0 10px rgba(239, 68, 68, 0.7)';
        } else {
          gtdButton.style.background = 'rgba(239, 68, 68, 0.18)';
          gtdButton.style.color = '#EF4444';
          gtdButton.style.boxShadow = 'none';
        }
      });
      this.realtimeSubscriptions.push(gtdSub);

      gtdButton.addEventListener('click', () => {
        this.showCesiumToolbarButtons();
        this.cdrGlobeService.closeBuildingCamera();
        this.gtdGlobeService.resetAllFilters();
        const isVisible = this.gtdGlobeService.isLayerVisible();
        if (!isVisible) {
          this.gtdGlobeService.setLayerVisibility(true);
          this.gtdGlobeService.setPanelOpen(false);
          this.gtdGlobeService.flyToNigeria();
        } else {
          this.gtdGlobeService.setLayerVisibility(false);
          this.gtdGlobeService.setPanelOpen(false);
        }
      });

      // Create the Flight Radar button with clear ON/OFF & Loading state styles
      const flightButton = document.createElement('button');
      flightButton.className = 'cesium-button flight-toolbar-btn';
      flightButton.style.display = 'inline-flex';
      flightButton.style.alignItems = 'center';
      flightButton.style.justifyContent = 'center';
      flightButton.style.width = '36px';
      flightButton.style.height = '36px';
      flightButton.style.padding = '0';
      flightButton.style.margin = '0 3px';
      flightButton.style.boxSizing = 'border-box';
      flightButton.style.borderRadius = '4px';
      flightButton.style.cursor = 'pointer';
      flightButton.style.verticalAlign = 'middle';

      const updateFlightButtonVisuals = () => {
        const isLoading = this.flightRadarGlobeService.isLoading;
        const visible = this.flightRadarGlobeService.isLayerVisible();

        if (isLoading) {
          flightButton.classList.add('active');
          flightButton.innerHTML = '<i class="fa-solid fa-spinner fa-spin" style="font-size: 20px; line-height: 1; pointer-events: none; color: #00D2FF;"></i>';
          flightButton.style.border = '1.5px solid #00D2FF';
          flightButton.style.background = 'rgba(0, 210, 255, 0.3)';
          flightButton.style.color = '#00D2FF';
          flightButton.style.boxShadow = '0 0 10px rgba(0, 210, 255, 0.5)';
          flightButton.title = 'Fetching Real-Time Flight Data...';
        } else if (visible) {
          flightButton.classList.add('active');
          flightButton.innerHTML = '<i class="fa-solid fa-plane" style="font-size: 20px; line-height: 1; pointer-events: none; color: #00D2FF;"></i>';
          flightButton.style.border = '1.5px solid #00D2FF';
          flightButton.style.background = 'rgba(0, 210, 255, 0.35)';
          flightButton.style.color = '#00D2FF';
          flightButton.style.boxShadow = '0 0 14px rgba(0, 210, 255, 0.9)';
          flightButton.title = 'Real-Time Global Flights Radar (ACTIVE - Click to Turn OFF)';
        } else {
          flightButton.classList.remove('active');
          flightButton.innerHTML = '<i class="fa-solid fa-plane" style="font-size: 20px; line-height: 1; pointer-events: none; color: #FFFFFF;"></i>';
          flightButton.style.border = '1.5px solid rgba(255, 255, 255, 0.4)';
          flightButton.style.background = 'rgba(255, 255, 255, 0.08)';
          flightButton.style.color = '#FFFFFF';
          flightButton.style.boxShadow = 'none';
          flightButton.title = 'Real-Time Global Flights Radar (OFF - Click to Turn ON)';
        }
      };

      this.realtimeSubscriptions.push(
        this.flightRadarGlobeService.isLayerVisible$.subscribe(() => updateFlightButtonVisuals()),
        this.flightRadarGlobeService.isLoading$.subscribe(() => updateFlightButtonVisuals())
      );
      updateFlightButtonVisuals();

      flightButton.addEventListener('click', () => {
        this.showCesiumToolbarButtons();
        this.cdrGlobeService.closeBuildingCamera();
        const isVisible = this.flightRadarGlobeService.isLayerVisible();
        this.flightRadarGlobeService.toggleLayer(!isVisible);
      });

      // Container for CDR, GTD, and Flight Radar buttons
      const intelGroup = document.createElement('div');
      intelGroup.className = 'cesium-toolbar-intel-group';
      intelGroup.style.display = 'inline-flex';
      intelGroup.style.alignItems = 'center';
      intelGroup.style.position = 'relative';
      intelGroup.style.right = '30px';
      intelGroup.style.gap = '6px';
      intelGroup.style.verticalAlign = 'middle';

      intelGroup.appendChild(flightButton);
      intelGroup.appendChild(cdrButton);
      intelGroup.appendChild(gtdButton);

      (toolbar as HTMLElement).style.display = 'flex';
      (toolbar as HTMLElement).style.alignItems = 'center';

      // Insert CDR & TD group before search icon (geocoder) or first element
      if (toolbar.firstChild) {
        toolbar.insertBefore(intelGroup, toolbar.firstChild);
      } else {
        toolbar.appendChild(intelGroup);
      }
      this.ensureVehicleViewButton(toolbar as HTMLElement);
    } else {
      if (existingIntelGroup) {
        existingIntelGroup.remove();
      }
      this.removeVehicleViewButton(toolbar as HTMLElement);
    }
  }

  showCesiumToolbarButtons(): void {
    if (!this.viewer) return;
    const v = this.viewer as any;

    // Show Home Button
    if (v.homeButton && v.homeButton._element) {
      const el = v.homeButton._element;
      if (el && el.style) {
        el.style.display = '';
      }
    }

    // Show Geocoder
    if (v.geocoder && v.geocoder._element) {
      const el = v.geocoder._element;
      if (el && el.style) {
        el.style.display = '';
      }
    }

    // Show Geocoder Container (Search Bar Container)
    const geocoderContainer = document.querySelector('.cesium-viewer-geocoderContainer');
    if (geocoderContainer && (geocoderContainer as HTMLElement).style) {
      (geocoderContainer as HTMLElement).style.display = '';
    }

    // Show BaseLayerPicker
    if (v.baseLayerPicker && v.baseLayerPicker._element) {
      const el = v.baseLayerPicker._element;
      if (el && el.style) {
        el.style.display = '';
      }
    }
  }

  // Add method to create notification badge
  private addNotificationBadge(button: HTMLButtonElement): void {
    // Subscribe to notification count updates
    const notificationSub = this.notificationService.notifications$.subscribe(notifications => {
      const unreadCount = notifications.length;

      // Remove existing badge
      const existingBadge = button.querySelector('.notification-badge');
      if (existingBadge) {
        existingBadge.remove();
      }

      // Add new badge if there are unread notifications
      if (unreadCount > 0) {
        const badge = document.createElement('span');
        badge.className = 'notification-badge';
        badge.textContent = unreadCount > 99 ? '99+' : unreadCount.toString();
        badge.style.cssText = `
          position: absolute;
        
          right: 2px;
          background: #dc3545;
          color: white;
          border-radius: 10px;
          padding: 2px 6px;
          font-size: 10px;
          font-weight: bold;
          min-width: 16px;
          text-align: center;
          z-index: 1000;
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
        `;
        button.appendChild(badge);
      }
    });

    this.realtimeSubscriptions.push(notificationSub);
  }

  // Update the handleNotifications method
  handleNotifications() {
    this.showNotifications = !this.showNotifications;
  }




  // Add separate method for API refresh
  private refreshNotificationsFromAPI(): void {

    // Show loading notification
    this.notificationService.addInfoNotification('Refreshing notifications from API...', {
      id: 'api-refresh-loading',
      duration: 2000
    });

    // Refresh from API
    this.realtimeService.showLatestApiDataAsNotifications();

    // Show success message
    setTimeout(() => {
      this.notificationService.addSuccessNotification('Notifications refreshed from API', {
        duration: 3000,
        moveToTop: false
      });
    }, 500);
  }


  onToolStateChange(isActive: boolean): void {
    this.isToolActive = isActive;
  }

  // Add method to get incident details for debugging
  logCurrentIncidents(): void {
    this.currentIncidents.forEach(incident => {
    });
  }

  handleDrawerAction(action: any): void {

    // Handle different drawer actions based on action type
    switch (action.type || action) {
      case 'settings':
        //this.handleSettings();
        break;

      case 'notifications':
        this.handleNotifications();
        break;

      case 'logout':
      case 'signout':
        //this.handleSignOut();
        break;

      case 'refresh':
        this.refreshData();
        break;

      case 'fullscreen':
        this.toggleFullscreen();
        break;

      case 'help':
        this.showHelp();
        break;

      case 'about':
        this.showAbout();
        break;

      default:
        // Handle unknown actions or show a generic message
        this.notificationService.addInfoNotification(
          `Action "${action.type || action}" triggered`,
          { duration: 2000 }
        );
    }
  }

  // Add supporting methods for the drawer actions:
  private refreshData(): void {

    // Add loading notification
    this.notificationService.addInfoNotification('Refreshing data...', {
      id: 'refresh-loading',
      duration: 2000
    });

    // Refresh real-time data
    this.realtimeService.fetchIncidentsAndNotify();

    // You can add other refresh logic here
    setTimeout(() => {
      this.notificationService.addSuccessNotification('Data refreshed successfully', {
        duration: 3000
      });
    }, 1000);
  }

  private toggleFullscreen(): void {

    if (!document.fullscreenElement) {
      // Enter fullscreen
      document.documentElement.requestFullscreen().then(() => {
        this.notificationService.addInfoNotification('Entered fullscreen mode', {
          duration: 2000
        });
      }).catch((error) => {
        console.error('Failed to enter fullscreen:', error);
        this.notificationService.addDangerNotification('Failed to enter fullscreen mode');
      });
    } else {
      // Exit fullscreen
      document.exitFullscreen().then(() => {
        this.notificationService.addInfoNotification('Exited fullscreen mode', {
          duration: 2000
        });
      }).catch((error) => {
        console.error('Failed to exit fullscreen:', error);
      });
    }
  }

  private showHelp(): void {

    // Show as a notification with longer duration
    this.notificationService.addInfoNotification('Help: Check console for navigation tips', {
      duration: 5000
    });


  }

  private showAbout(): void {

    const aboutInfo = {
      title: 'Illum Live Globe',
      version: '1.0.0',
      description: 'Interactive 3D globe for incident management and real-time monitoring',
      features: [
        'Real-time incident tracking',
        'Interactive notifications',
        'Live data visualization',
        '3D globe navigation'
      ]
    };

    // Show as notification or modal
    this.notificationService.addInfoNotification(
      `${aboutInfo.title} v${aboutInfo.version} - ${aboutInfo.description}`,
      { duration: 5000 }
    );

  }

  handleSignOut() {
    // Close notification panel on logout
    this.showNotifications = false;
    this.modalService.open(LogoutComponent, {
      // size: 'sm',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  handleSettings() {
    this.modalService.open(SettingsDialogComponent, {
      // size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  getRegionColor(region: string): string {
    return REGION_COLORS[region] || '#00F0FF';
  }

  getTooltipLeft(x: number): number {
    if (typeof window !== 'undefined') {
      const maxLeft = window.innerWidth - 260;
      return Math.max(12, Math.min(x + 16, maxLeft));
    }
    return x + 16;
  }

  getTooltipTop(y: number): number {
    if (typeof window !== 'undefined') {
      const maxTop = window.innerHeight - 230;
      return Math.max(12, Math.min(y - 20, maxTop));
    }
    return y - 20;
  }

  dismissVehicleHover(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.vehicleMarkers.dismissHover();
  }
}

